import type { WithoutDataType } from '@docue/builder/types'

import { BROWSER_SESSION } from '~/types'

import type { Options } from '../useInternalApi'

import { useInternalApi } from '../useInternalApi'
import { useFetchSession } from '../session/useFetchSession'

export type BrowserAuthData =
  App.Http.InternalApi.BrowsingSession.Data.SessionAuthenticateData

export type BrowserSessionData =
  App.Http.InternalApi.BrowsingSession.Data.SessionData

export type AuthenticateBrowserSessionPayload =
  WithoutDataType<App.Http.InternalApi.BrowsingSession.Payload.SessionAuthenticatePayload>

export type CompleteBrowserSessionPayload =
  WithoutDataType<App.Http.InternalApi.BrowsingSession.Payload.SessionCompletePayload>

export const useFetchBrowserSession = () => {
  const { post, getUrl } = useInternalApi()
  const { authenticate, getCurrent } = useFetchSession<BrowserAuthData, BrowserSessionData, AuthenticateBrowserSessionPayload>(BROWSER_SESSION)

  const complete = ({
    payload,
    options = {},
  }: {
    payload: CompleteBrowserSessionPayload
    options?: Options
  }) =>
    post<BrowserSessionData>({
      url: getUrl(BROWSER_SESSION, 'sessions/current/complete'),
      accessType: BROWSER_SESSION,
      options: {
        body: payload,
        ...options,
      },
    }).then(res => res.data)

  return {
    authenticate,
    getCurrent,
    complete,
  }
}
